export default __webpack_public_path__ + "static/media/Vended_1.8e79579d.jpg";